export default __webpack_public_path__ + "static/media/bullet-list-block-thumbnail-light.bcd4fe1d.svg";